// @ts-nocheck

import React, { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFutureOdds, requestToggleMyMatchMode } from '../../actions/mymatch';
import { send } from '../../actions/network';
import deferComponentRender from '../../hocs/deferComponentRender';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import { makeMatchIsMyMatchAvailableSelector } from '../../selectors/mymatch.selector';
import { MatchViewModes } from '../../types/matchView';
import { Routes } from '../../types/routes';

import RoutesMatch from './RoutesMatch';
import selectRouteMatchProps from './RoutesMatch.selector';

const RoutesMatchContainer = () => {
  const dispatch = useDispatch();
  const {
    params: { matchId: rawMatchId },
  } = useRouter();
  const matchId = useMemo(() => (rawMatchId ? parseInt(rawMatchId, 10) : null), [rawMatchId]);

  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const { summaryComputed, ...selectedProps } = useSelector((state) => selectRouteMatchProps(state, selectorProps));
  const selectMatchIsMyMatchAvailable = useMemo(() => makeMatchIsMyMatchAvailableSelector(), []);
  const isMyMatchAvailable = useSelector((state) => selectMatchIsMyMatchAvailable(state, selectorProps));
  const { matchViewMode } = selectedProps;

  const enhancedProps = useMergeProps({ selectedProps });

  useEffect(() => {
    if (matchId) {
      dispatch(send({ route: `${Routes.MATCH}:${matchId}` }));
    }
  }, [dispatch, matchId]);

  useEffect(() => {
    if (isMyMatchAvailable) {
      dispatch(getFutureOdds({ matchId, forceWithLease: true }));
    }
  }, [dispatch, isMyMatchAvailable, matchId]);

  useEffect(() => {
    if (matchViewMode === MatchViewModes.MY_MATCH && !isMyMatchAvailable) {
      dispatch(requestToggleMyMatchMode({ matchId }));
    }
  }, [matchViewMode, isMyMatchAvailable, dispatch, matchId]);

  const summaryComputedRef = useRef(summaryComputed ?? false);

  useEffect(() => {
    if (!summaryComputedRef.current && summaryComputed && typeof matchId === 'number') {
      dispatch(send({ route: `${Routes.MATCH}:${matchId}` }));
      summaryComputedRef.current = true;
    }
  }, [summaryComputed, matchId, dispatch]);

  return <RoutesMatch {...enhancedProps} />;
};

export default deferComponentRender(RoutesMatchContainer);
